// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true*/

export const editor_value_to_string = (value: unknown)=>{
    if (!value)
        return '';
    if (typeof value=='string')
        return value;
    if (typeof value=='number')
        return Number.prototype.toString.call(value);
    if (typeof value=='boolean')
        return value ? 'true' : 'false';
    try {
        const serialized = JSON.stringify(value);
        return serialized===undefined
            ? '[Unable to display value: value cannot be serialized as JSON]'
            : serialized;
    } catch(e){
        const message = e instanceof Error ? e.message
            : 'value cannot be serialized as JSON';
        return `[Unable to display value: ${message}]`;
    }
};
